/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (terminals) => ({
    type: actions.TERMINALS_RECEIVE,
    payload: { terminals },
});